import classNames from "classnames";
import styles from "./ProductDotsButton.module.scss";

type Props = {
    dots: number[];
    selectedIndex: number;
    onDotClick: (index: number) => void;
}

export const ProductDotsButton = ({dots, selectedIndex, onDotClick}: Props) => {
    return (
        <div className={styles.dots}>
            {dots.map((_, index) => (
                <button
                    key={`dot-${index}`}
                    onClick={() => onDotClick(index)}
                    className={classNames(styles.dot, {
                        [styles.selected]: index === selectedIndex,
                    })}
                />
            ))}
        </div>
    );
}
